import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { FormattedMessage } from 'dibs-react-intl';
import { HpSharedMostSavedItemsCarousel } from '../HpSharedMostSavedItemsCarousel/HpSharedMostSavedItemsCarousel.tsx';
import { HpSharedExcellentValuesCarousel } from '../HpSharedExcellentValuesCarousel/HpSharedExcellentValuesCarousel.tsx';
import { HpSharedBestsellingDesignsCarousel } from '../HpSharedBestsellingDesignsCarousel/HpSharedBestsellingDesignsCarousel.tsx';

import { type HpSharedLocationsModule_viewer$key } from './__generated__/HpSharedLocationsModule_viewer.graphql.ts';
import { type HpSharedLocationsModule_user$key } from './__generated__/HpSharedLocationsModule_user.graphql.ts';

const viewerFragment = graphql`
    fragment HpSharedLocationsModule_viewer on Viewer {
        ...HpSharedMostSavedItemsCarousel_viewer
        ...HpSharedExcellentValuesCarousel_viewer
        ...HpSharedBestsellingDesignsCarousel_viewer
    }
`;

const userFragment = graphql`
    fragment HpSharedLocationsModule_user on User {
        ...HpSharedMostSavedItemsCarousel_user
        ...HpSharedExcellentValuesCarousel_user
        ...HpSharedBestsellingDesignsCarousel_user
    }
`;

export const HpSharedLocationsModule: FC<{
    viewer: HpSharedLocationsModule_viewer$key | null;
    user?: HpSharedLocationsModule_user$key | null;
    isMobile: boolean;
}> = ({ viewer: viewerRef, user: userRef, isMobile }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const user = useFragment(userFragment, userRef);

    return (
        <>
            <HpSharedMostSavedItemsCarousel
                viewer={viewer}
                user={user}
                isMobile={isMobile}
                title={
                    <FormattedMessage
                        id="HpSharedMostSavedItemsCarousel.title"
                        defaultMessage="Most-Saved Items"
                    />
                }
                viewMoreLink="/collections/most-saved-items/?sort=newest"
            />
            <HpSharedExcellentValuesCarousel
                viewer={viewer}
                user={user}
                isMobile={isMobile}
                title={
                    <FormattedMessage
                        id="HpSharedExcellentValuesCarousel.title"
                        defaultMessage="Excellent Values"
                    />
                }
                viewMoreLink="/collections/excellent-values/?sort=newest"
            />
            <HpSharedBestsellingDesignsCarousel
                viewer={viewer}
                user={user}
                isMobile={isMobile}
                title={
                    <FormattedMessage
                        id="HpSharedBestsellingDesignsCarousel.title"
                        defaultMessage="Bestselling Designs"
                    />
                }
                viewMoreLink="/collections/best-sellers/?sort=newest"
            />
        </>
    );
};
